const formatCertDate = isoString => {
  if (!isoString) {
    return null;
  }

  const date = new Date(isoString);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

// A certification has no human name — it is identified by its lifecycle status
// plus the most decision-relevant date (expiry > approval > submission).
export const buildCertificationOptionLabel = certification => {
  const status = certification?.status ?? 'Unknown';

  const expires = formatCertDate(certification?.expiresAt);

  if (expires) {
    return `${status} · expires ${expires}`;
  }

  const approved = formatCertDate(certification?.approvedAt);

  if (approved) {
    return `${status} · approved ${approved}`;
  }

  const submitted = formatCertDate(certification?.submittedAt);

  if (submitted) {
    return `${status} · submitted ${submitted}`;
  }

  return status;
};
